import { JobsContainer, SearchContainer } from "../../components";

const Alljobs = () => {
	return (
		<>
			<SearchContainer />
			<JobsContainer />
		</>
	);
};

export default Alljobs;
